import type { ReactNode } from "react";
import { useRouterState } from "@tanstack/react-router";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileCTABar } from "./MobileCTABar";

export function SiteLayout({ children }: { children: ReactNode }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isAdminRoute = pathname.startsWith("/admin");
  const isStudioRoute = pathname === "/studio" || pathname.startsWith("/studio/");
  const isPortalRoute = pathname === "/portal" || pathname.startsWith("/portal/");

  return (
    <div className="min-h-screen bg-brand-ivory text-brand-navy flex flex-col">
      {!isAdminRoute && !isPortalRoute && <Header />}
      <main className={`flex-1 ${isAdminRoute || isPortalRoute ? "" : "pt-14 sm:pt-20 lg:pt-0"} ${isAdminRoute || isStudioRoute || isPortalRoute ? "" : "pb-20 lg:pb-0"}`}>{children}</main>
      {!isAdminRoute && !isPortalRoute && <Footer />}
      {!isAdminRoute && !isStudioRoute && !isPortalRoute && <MobileCTABar />}
    </div>
  );
}

